jQuery.extend({
    googlepush: function (events, action, label, value, flag) {
        if (NHS.Scripts !== undefined && NHS.Scripts.Helper !== undefined) 
            NHS.Scripts.Helper.createCookie("CTAName", action);
        if (typeof dataLayer != 'undefined') {
            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': events,
                'eventAction': action,
                'eventLabel': label,
                'eventValue': undefined
            });
        }
    },
    
    SetDataLayerPair: function (key, optValue) {
            var finalUrl = "/GoogleAnalytics/SetDataLayerPair";

            if (typeof (optValue) == 'undefined')
                optValue = 0;
            
            jQuery.ajax({
                type: "GET",
                url: finalUrl,
                data: { key: key, optValue: optValue },
                success: function (data) {
                    if (data != "" && typeof data === 'string') {
                        if (typeof (dataLayer) == 'undefined') {
                            var tmpData = data;
                            var finalData = tmpData.replace("dataLayer", "window.parent.dataLayer");
                            eval(finalData);
                        }
                        else
                            eval(data);                        
                    }
                },
                error: function (data) {
                }
            });
    },
    SetDataLayer: function(key, value) {
        if (typeof dataLayer != 'undefined') {
            dataLayer.push({ key: value });
        }
         else {
             window.parent.dataLayer.push({ key: value });
        }
    },
});